<main class="dashboard" @fadeSlideInUp>
    <web-alert-cards></web-alert-cards>
    <section class="dashboard-main-section">
        <div class="dashboard-main-section-left">
            <ng-container *ngIf="!(loanDashboardService.loanDashboardSimmer | async)">
                <router-outlet></router-outlet>
            </ng-container>
            <!-- <web-loan-dashboard-shimmer
                *ngIf="loanDashboardService.loanDashboardSimmer | async"
                class="open-page-animate"
            ></web-loan-dashboard-shimmer> -->
            <!-- <web-time-line-shimmer class="open-page-animate"></web-time-line-shimmer> -->
            <web-time-line-shimmer
                *ngIf="loanDashboardService.loanDashboardSimmer | async"
                class="open-page-animate"
            ></web-time-line-shimmer>
        </div>

        <ng-container *ngIf="isMobile">
            <ng-container
                class="swiper"
                *ngIf="!(loanDashboardService.loanDashboardSimmer | async) && infoCard['infoCard']?.length > 0"
            >
                <ng-container *ngTemplateOutlet="bannerTemplate"></ng-container>
            </ng-container>

            <div class="skeleton-main-card" *ngIf="loanDashboardService.loanDashboardSimmer | async">
                <div class="squire skeleton h100"></div>
                <div class="squire skeleton h100"></div>
            </div>
        </ng-container>

        <aside class="dashboard-main-section-right">
            <div class="quick-access">
                <h3 class="title-main">Quick Access</h3>
                <div class="quick-access-list">
                    <div class="quick-access-list-item" (click)="goToReferAndEarn()">
                        <div class="quick-access-list-item-content">
                            <span class="icon icon-40" svgIcon="assets/svg/icons/wallet-fill-gb.svg"></span>
                            <div class="quick-access-list-item-content-description">
                                <h3 class="title">Refer & Earn</h3>
                                <p class="desc">Refer friends and get rewarded.</p>
                            </div>
                        </div>
                        <div class="quick-access-list-item-right">
                            <img class="icon icon-primary" src="assets/svg/icons/chevron-right.svg" />
                        </div>
                    </div>
                    <div class="quick-access-list-item" [routerLink]="'/reward-wallet'">
                        <div class="quick-access-list-item-content">
                            <span class="icon icon-40" svgIcon="assets/svg/icons/brand-icon-fill-b.svg"></span>
                            <div class="quick-access-list-item-content-description">
                                <h3 class="title">Klinq Membership</h3>
                                <p class="desc">Earn points at every step</p>
                            </div>
                        </div>
                        <div class="quick-access-list-item-right">
                            <img class="icon icon-primary" src="assets/svg/icons/chevron-right.svg" />
                        </div>
                    </div>
                    <div class="quick-access-list-item" [routerLink]="'/emi-calculator'">
                        <div class="quick-access-list-item-content">
                            <span class="icon icon-40" svgIcon="assets/svg/icons/calculator-gb.svg"></span>
                            <div class="quick-access-list-item-content-description">
                                <h3 class="title">EMI Calculator</h3>
                                <p class="desc">Plan your monthly EMIs easily</p>
                            </div>
                        </div>
                        <div class="quick-access-list-item-right">
                            <img class="icon icon-primary" src="assets/svg/icons/chevron-right.svg" />
                        </div>
                    </div>
                    <div class="quick-access-list-item" *ngIf="showCibil" (click)="goToD2cDetails()">
                        <div class="quick-access-list-item-content">
                            <span class="icon icon-40" svgIcon="assets/svg/icons/analytics-gb.svg"></span>
                            <div class="quick-access-list-item-content-description">
                                <h3 class="title">Check CIBIL score</h3>
                                <p class="desc">View your credit report for free</p>
                            </div>
                        </div>
                        <div class="quick-access-list-item-right">
                            <img class="icon icon-primary" src="assets/svg/icons/chevron-right.svg" />
                        </div>
                    </div>
                </div>
            </div>
        </aside>
        <ng-container *ngIf="!isMobile">
            <ng-container
                class="swiper"
                *ngIf="!(loanDashboardService.loanDashboardSimmer | async) && infoCard['infoCard']?.length > 0"
            >
                <ng-container *ngTemplateOutlet="bannerTemplate"></ng-container>
            </ng-container>

            <div class="skeleton-main-card" *ngIf="loanDashboardService.loanDashboardSimmer | async">
                <div class="squire skeleton h100"></div>
                <div class="squire skeleton h100"></div>
                <div class="squire skeleton h100"></div>
                <div class="squire skeleton h100"></div>
            </div>
        </ng-container>
    </section>

    <ng-template #bannerTemplate>
        <section class="banner">
            <h3 class="title-main" *ngIf="infoCard['title'] != ''">{{ infoCard["title"] }}</h3>
            <div class="banner-list">
                <div class="swiper mySwiper" #bannerSwiper>
                    <div class="swiper-wrapper">
                        <div class="swiper-slide slide-item" *ngFor="let item of infoCard['infoCard']">
                            <div class="slide-item-media">
                                <img [src]="item?.imageUrl" />
                            </div>
                            <div class="slide-item-content">
                                <p class="desc">{{ item?.subTitle }}</p>
                                <h3 class="title">{{ item?.title }}</h3>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-button-prev"></div>
                    <div class="swiper-button-next"></div>
                </div>
            </div>
        </section>
    </ng-template>

    <!-- <section class="learn">
        <h3 class="title-main">Learn & Grow with Klinq</h3>
        <div class="learn-list">
            <div class="learn-list-item">
                <div class="learn-list-item-media">
                    <img src="assets/images/learn01.webp" />
                </div>
                <div class="learn-list-item-content">
                    <div class="learn-list-item-content-description">
                        <h3 class="title">What affects your CIBIL score over time</h3>
                    </div>
                    <div class="learn-list-item-content-action">
                        <button type="text" class="primary-fill-btn learn-btn">
                            Learn More <img class="icon icon-primary" src="assets/svg/icons/arrow-right.svg" />
                        </button>
                    </div>
                </div>
            </div>
            <div class="learn-list-item">
                <div class="learn-list-item-media">
                    <img src="assets/images/learn02.webp" />
                </div>
                <div class="learn-list-item-content">
                    <div class="learn-list-item-content-description">
                        <h3 class="title">Smart money habits at the start of career</h3>
                    </div>
                    <div class="learn-list-item-content-action">
                        <button type="text" class="primary-fill-btn learn-btn">
                            Learn More <img class="icon icon-primary" src="assets/svg/icons/arrow-right.svg" />
                        </button>
                    </div>
                </div>
            </div>
            <div class="learn-list-item">
                <div class="learn-list-item-media">
                    <img src="assets/images/learn03.webp" />
                </div>
                <div class="learn-list-item-content">
                    <div class="learn-list-item-content-description">
                        <h3 class="title">How to build a good financial profile</h3>
                    </div>
                    <div class="learn-list-item-content-action">
                        <button type="text" class="primary-fill-btn learn-btn">
                            Learn More <img class="icon icon-primary" src="assets/svg/icons/arrow-right.svg" />
                        </button>
                    </div>
                </div>
            </div>
            <div class="learn-list-item">
                <div class="learn-list-item-media">
                    <img src="assets/images/learn03.webp" />
                </div>
                <div class="learn-list-item-content">
                    <div class="learn-list-item-content-description">
                        <h3 class="title">How to build a good financial profile</h3>
                    </div>
                    <div class="learn-list-item-content-action">
                        <button type="text" class="primary-fill-btn learn-btn">
                            Learn More <img class="icon icon-primary" src="assets/svg/icons/arrow-right.svg" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="community">
        <h3 class="title-main">From the klinq Community</h3>
        <div class="community-list">
            <div class="community-list-item">
                <div class="community-list-item-media">
                    <img class="icon" src="assets/images/community01.webp" />
                </div>
                <div class="community-list-item-content">
                    <div class="community-list-item-content-description">
                        <h3 class="title">Here is how Klinq helped Dinesh to get his new bike</h3>
                    </div>
                    <div class="community-list-item-content-right">
                        <img class="icon icon-primary" src="assets/svg/icons/arrow-right-up.svg" />
                    </div>
                </div>
            </div>
            <div class="community-list-item">
                <div class="community-list-item-media">
                    <img class="icon" src="assets/images/community01.webp" />
                </div>
                <div class="community-list-item-content">
                    <div class="community-list-item-content-description">
                        <h3 class="title">Here is how Klinq helped Dinesh to get his new bike</h3>
                    </div>
                    <div class="community-list-item-content-right">
                        <img class="icon icon-primary" src="assets/svg/icons/arrow-right-up.svg" />
                    </div>
                </div>
            </div>
            <div class="community-list-item">
                <div class="community-list-item-media">
                    <img class="icon" src="assets/images/community01.webp" />
                </div>
                <div class="community-list-item-content">
                    <div class="community-list-item-content-description">
                        <h3 class="title">Here is how Klinq helped Dinesh to get his new bike</h3>
                    </div>
                    <div class="community-list-item-content-right">
                        <img class="icon icon-primary" src="assets/svg/icons/arrow-right-up.svg" />
                    </div>
                </div>
            </div>
            <div class="community-list-item">
                <div class="community-list-item-media">
                    <img class="icon" src="assets/images/community01.webp" />
                </div>
                <div class="community-list-item-content">
                    <div class="community-list-item-content-description">
                        <h3 class="title">Here is how Klinq helped Dinesh to get his new bike</h3>
                    </div>
                    <div class="community-list-item-content-right">
                        <img class="icon icon-primary" src="assets/svg/icons/arrow-right-up.svg" />
                    </div>
                </div>
            </div>
        </div>
    </section> -->
</main>
